import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import services from './services.js';
//组件
import baseInfoForm from '../../../components/agent-base-infonew';
import contactForm from '../../../components/agent-contactnew';
import agentInfo from '../../../components/agent-infonew';
import operateAddressDialog from 'operateAddressDialog';
import selectStaffDialog from 'selectStaffDialog';

//import address from 'agent-address';
//import agentSignMaterielv from 'agent-sign-materiel';
export default {
    mixins: [services],
    components: {
        'base-info-form': baseInfoForm,
        'contact-form': contactForm,
        'agent-info': agentInfo,
        operateAddressDialog,
        selectStaffDialog,
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            baseInfo: null,
            title: '',
            form: this.getFormData(),
            dialogObj: '', //判断是招商还是业务经理
            isRequired: false, //判断必填字段
            isPerson: true, //判断个人
        };
    },
    computed: {
        sysSid: function () {
            return this.$store.state.sysSid;
        },
        sysSession: function () {
            return this.$store.state.sysSession;
        }
    },
    watch: {

    },
    methods: {
        getFormData() {
            return cloneDeep({
                Id: '',
                Industry_Id: 9,
                Customer: {}
            });
        },
        show(options) {
            this.dialogVisible = true
            this.title = options.title
            this.loading = false
            this.$nextTick(() => {
                this.form = this.getFormData()
                this.$refs.baseInfo.resetFields();
                this.baseInfo = {
                    BusEmployeeName: options.BusEmployeeName,
                    BusEmployeeId: options.BusEmployeeId,
                    LeasingManagerName: options.LeasingManagerName,
                    LeasingManagerId: options.LeasingManagerId
                }
                this.form.Id = options.Id
            })


        },
        changeAgentType(val) {
            if (val == 14) {
                // 公司
                this.isRequired = true
            } else {
                // 个人
                this.isRequired = false
            }
        },
        showSelectStaffDialog(val) {
            this.dialogObj = val
            this.$refs.refSelectStaffDialog.show();
        },
        //选择员工
        selectedStaff(item) {
            if (item !== undefined) {
                if (this.dialogObj == 'Manager') {
                    // 招商经理信息
                    this.$refs.baseInfo.setStaffInfo2(item);
                } else {
                    this.$refs.baseInfo.setStaffInfo(item);
                }
            }


        },

        //关闭弹窗
        close() {
            this.dialogVisible = false;
        },
        submit() {

            this.$nextTick(() => {

                let baseInfo = this.$refs.baseInfo.validate(); //公司基本信息
                this.form.Customer = cloneDeep(baseInfo)
                if (!!baseInfo) {
                    // 新增
                    this.NewCompanyAdd(this.form)
                }

            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/CRMFormatAgent/components/addCompany/vm.js